import { render, staticRenderFns } from "./NotAllowedAlert.vue?vue&type=template&id=4e2eb8b5&scoped=true&"
import script from "./NotAllowedAlert.vue?vue&type=script&lang=js&"
export * from "./NotAllowedAlert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e2eb8b5",
  null
  
)

export default component.exports